import { Calendar } from 'antd';
import { ICalendarMode, ICalendarProps } from './entities';

import Styles from './assets/styles.scss';

const BCCalendar = (props: ICalendarProps<any>) => {
	Styles;

	const {
		className,
		value,
		defaultValue,
		mode,
		fullscreen,
		locale,
		style,
		onPanelChange,
		onSelect,
		onChange,
		disabledDate,
		validRange
	} = props;

	return (
		<Calendar
			className={className}
			value={value}
			defaultValue={defaultValue}
			mode={mode}
			fullscreen={fullscreen}
			locale={locale}
			style={style}
			onPanelChange={onPanelChange}
			onSelect={onSelect}
			onChange={onChange}
			disabledDate={disabledDate}
			validRange={validRange}
		/>
	);
};
export default BCCalendar;
export { ICalendarMode, ICalendarProps };
